import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { ref, computed, onMounted } from "vue";

import ListItemsWithTableLayout from "@/widgets/layouts/ListItemsWithTableLayout.vue";
import TopListUsersPanel from "@/entities/dictionaries/users/panels/TopListUsersPanel.vue";
import Paginator from "primevue/paginator";
import EmptyTableMessage from "@/entities/segments/EmptyTableMessage.vue";
import UsersTable from "@/entities/dictionaries/users/UsersTable.vue";
import UsersFilterForm from "@/entities/dictionaries/users/forms/UsersFilterForm.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";

import { rowsCount } from "@/services/utils/Pagination";
import { useUsersStore, UsersParams } from "@/store/users/users";
import {
  setUsersParamsByFilter,
  FilterForm,
} from "@/services/dictionaries/users";
import { useAuthStore } from "@/store/auth/login";


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersPage',
  setup(__props) {

const isFilterEnabled = ref(false);
const isFilterSetted = ref(false);
const isLoading = ref(false);
const authStore = useAuthStore();
const tableDisplaySettings = ref({
  first: 0,
  orderField: "",
  commonFilter: "",
  filter: {} as FilterForm,
});
const store = useUsersStore();
const filteredUsers = computed(() => {
  return store.usersList;
});

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:read", "system:edit"],
    ["users:read", "users:edit"],
    ["dictionaries:read", "dictionaries:edit"]
  );
});

const activeFirstFromStore = computed(() => store.activeFirst);

onMounted(() => {
  if (isDenied.value) return;
  loadData();
});

const loadData = () => {
  isLoading.value = true;
  updateUsersList();
};

const setCommonFilter = (filter: string) => {
  tableDisplaySettings.value.commonFilter = filter;
  updateUsersList();
};

const setFilter = (filter: FilterForm, isSetted: boolean) => {
  tableDisplaySettings.value.filter = filter;
  isFilterSetted.value = isSetted;
  updateUsersList();
};

const sortTable = (order_by: string) => {
  tableDisplaySettings.value.orderField = order_by;
  updateUsersList();
};

const updateUsersList = () => {
  let isEnded = false;
  setTimeout(() => {
    if (!isEnded) {
      isLoading.value = true;
    }
  }, 200);

  const params: UsersParams = {
    page: tableDisplaySettings.value.first + 1,
    per_page: rowsCount(43),
  };

  setUsersParamsByFilter(params, tableDisplaySettings.value);

  store.getUsers(params).finally(() => {
    isLoading.value = false;
    isEnded = true;
  });
};

let resizeTimeout: number;

window.addEventListener("resize", function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(updateUsersList, 200);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListItemsWithTableLayout, null, {
    body: _withCtx(() => [
      _createVNode(HandlerAccessDenied, { "is-denied": isDenied.value }, {
        default: _withCtx(() => [
          _createVNode(UsersFilterForm, {
            isFilterEnabled: isFilterEnabled.value,
            onToggleFilter: _cache[0] || (_cache[0] = ($event: any) => (isFilterEnabled.value = !isFilterEnabled.value)),
            onSetFilter: setFilter
          }, null, 8, ["isFilterEnabled"]),
          _createVNode(TopListUsersPanel, {
            onSetCommonFilter: setCommonFilter,
            onToggleFilter: _cache[1] || (_cache[1] = ($event: any) => (isFilterEnabled.value = !isFilterEnabled.value)),
            isFilterEnabled: isFilterEnabled.value,
            isFilterSetted: isFilterSetted.value
          }, null, 8, ["isFilterEnabled", "isFilterSetted"]),
          _createElementVNode("div", {
            id: "table-container",
            class: _normalizeClass(["table-container flex flex-col", [
            filteredUsers.value && filteredUsers.value.length == 0 ? 'empty' : 'filled',
          ]])
          }, [
            _createVNode(UsersTable, {
              users: filteredUsers.value,
              isActiveFirst: activeFirstFromStore.value,
              isLoading: isLoading.value,
              rowsCount: _unref(rowsCount)(43) * tableDisplaySettings.value.first,
              onSortTable: sortTable,
              onUpdateTable: updateUsersList
            }, null, 8, ["users", "isActiveFirst", "isLoading", "rowsCount"]),
            (filteredUsers.value && filteredUsers.value.length == 0 && !isLoading.value)
              ? (_openBlock(), _createBlock(EmptyTableMessage, { key: 0 }, {
                  text: _withCtx(() => [
                    _createTextVNode(" Примените другой фильтр или создайте первого пользователя. "),
                    _hoisted_1,
                    _createTextVNode(" Для этого кликните на кнопку \"Создать пользователя\". ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 2),
          _createVNode(_unref(Paginator), {
            first: tableDisplaySettings.value.first,
            "onUpdate:first": [
              _cache[2] || (_cache[2] = ($event: any) => ((tableDisplaySettings.value.first) = $event)),
              updateUsersList
            ],
            rows: 1,
            class: "s-paginator",
            totalRecords: _unref(store).usersPagesCount,
            template: "PrevPageLink CurrentPageReport NextPageLink",
            currentPageReportTemplate: "{first} из {totalRecords}"
          }, null, 8, ["first", "totalRecords"])
        ]),
        _: 1
      }, 8, ["is-denied"])
    ]),
    _: 1
  }))
}
}

})